import styled from 'styled-components'
import { Select as BaseSelect } from 'antd'

export const Container = styled.div`
  width: 20rem;
`
export const Select = styled(BaseSelect)`
  width: 100%;
`
